import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {filter} from 'rxjs/operators';
import {SubscriptionLike} from 'rxjs';
import {InternalRoutes} from '../../../models/internal-routes';
import {CurrentContextState} from '../../../redux/current-context/reducer/current-context.reducer';
import {CurrentModule} from '../../../models/current-module';
import {AuthenticationService} from '../../../../entry-routes/authentication/authentication.service';
import {ConfigurationService, whenConfReady} from '../../../../entry-routes/configuration/configuration.service';
import {Store} from "@ngrx/store";
import {selectCurrentContextFeature} from "../../../redux/current-context/current-context-selectors";
import { Router, RouterLink } from "@angular/router";
import { NgTemplateOutlet, NgIf } from '@angular/common';

@Component({
    selector: 'app-logo-nexia',
    templateUrl: './logo-nexia.component.html',
    styleUrls: ['./logo-nexia.component.scss'],
    standalone: true,
    imports: [RouterLink, NgTemplateOutlet, NgIf]
})
export class LogoNexiaComponent implements OnInit, OnDestroy {

  currentContext$ = this.store.select(selectCurrentContextFeature).pipe(whenConfReady);

  @Input()
  fullWhiteLogo = false;

  @Input()
  fullBlackLogo = false;

  @Input()
  firstLetterBlackLogo = false;
  public isGed = false;
  InternalRoutes = InternalRoutes;
  private subs: SubscriptionLike[] = [];

  constructor(
    private authenticationService: AuthenticationService,
    private configurationActions: ConfigurationService,
    private router: Router,
    private store: Store
  ) {
  }

  ngOnInit(): void {
    this.subs.push(this.currentContext$.pipe(
      filter((currentContext: CurrentContextState) => !!currentContext && !!currentContext.datas && !!currentContext.datas.currentModule && !currentContext.loading),
    ).subscribe((currentContextState: CurrentContextState) => {
      this.isGed = currentContextState.datas.currentModule === CurrentModule.GED;
    }));
  }

  ngOnDestroy(): void {
    this.subs.forEach((subscription) => subscription.unsubscribe());
  }
}
